<template>
    <modal :hideFooter="true" @close="closeFromModal">
        <template #header>
            <h5>{{ $tl("labels.clickAndCollect.editStock.stockManagement") }}</h5>
        </template>
        <template #body>
            <edit-stock
                :product_id="product_id"
                :date="date"
                :restaurant_id="restaurant_id"
                @product-unavailability-saved="$emit('product-unavailability-saved', $event)"
                @close="$emit('close')">
            </edit-stock>
        </template>
    </modal>
</template>

<script>
import editStock from "./EditStock.vue";
export default {
    name: "StockModal",
    components: {
        editStock,
    },
    props: {
        product_id: {
            type: Number,
            required: true,
        },
        date: {
            type: String,
            required: true,
        },
        restaurant_id: {
            type: Number,
            required: true,
        },
    },
    methods: {
        close() {
            this.$emit("close");
        },
        closeFromModal: function (e) {
            if (e && e.target && !e.target.classList.contains("modal-wrapper")) {
                e.stopPropagation();
            } else {
                this.close();
            }
        },
    },
};
</script>
